import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const AGENT_SITE_SETTINGS_PATH = "/api/agent/site-settings";

function agentSiteSettingsUrl() {
  return resolveApiUrl(AGENT_SITE_SETTINGS_PATH);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("agent_site_settings_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "Content-Type": "application/json",
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 20000,
    sid,
  };
}

export async function fetchAgentSiteSettings() {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.get(agentSiteSettingsUrl(), cfg);
  return data;
}

export async function saveAgentSiteSettings(payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.put(
    agentSiteSettingsUrl(),
    {
      ...payload,
      sessionID: cfg.sid,
    },
    cfg
  );
  return data;
}
